// src/components/ui/label.jsx
import React, { forwardRef } from "react";

export const Label = forwardRef(({ className = "", ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={`text-sm font-medium text-gray-700 ${className}`}
      {...props}
    />
  );
});

Label.displayName = "Label";
